<script setup lang="ts">
import { useToastStore } from '@/stores/toast'
import { storeToRefs } from 'pinia'

const toast = useToastStore()
const { message, type, visible } = storeToRefs(toast)
</script>

<template>
  <Teleport to="body">
    <Transition name="toast">
      <div
        v-if="visible"
        role="alert"
        class="fixed left-4 right-4 z-[100] max-w-md mx-auto px-4 py-3 rounded-xl shadow-lg flex items-center gap-3 min-h-[48px]"
        style="top: calc(1rem + env(safe-area-inset-top, 0px));"
        :class="{
          'bg-primary/95 text-white': type === 'success',
          'bg-red-500/95 text-white': type === 'error',
          'bg-gray-800/95 text-white': type === 'info',
        }"
        @click="toast.dismiss()"
      >
        <span
          class="material-symbols-outlined flex-shrink-0"
          :class="{ 'text-2xl': true }"
        >
          {{ type === 'success' ? 'check_circle' : type === 'error' ? 'error' : 'info' }}
        </span>
        <p class="flex-1 text-sm font-medium">{{ message }}</p>
        <button
          type="button"
          class="p-1 rounded-lg hover:bg-white/20 transition-colors min-w-[36px] min-h-[36px] flex items-center justify-center"
          aria-label="Dismiss"
          @click.stop="toast.dismiss()"
        >
          <span class="material-symbols-outlined text-lg">close</span>
        </button>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.25s ease;
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}
</style>
